  import { defineComponent, type PropType } from "vue";
  import ApprentiDateDebut from '@/extend/controls/apprenti/ApprentiDateDebut';
  import { Period } from '@/framework/base/helpers/DateFormat';
  import ApprentiDateFin from '@/extend/controls/apprenti/ApprentiDateFin';
  import ApprentiDateRupture from '@/extend/controls/apprenti/ApprentiDateRupture';
  import ApprentiNom from '@/extend/controls/apprenti/ApprentiNom';
  import ApprentiPrenom from '@/extend/controls/apprenti/ApprentiPrenom';
  import CiviliteSelect from '@/extend/controls/civilite/CiviliteSelect';
  import Apprenti from '@/extend/classes/Apprenti';
  import { FieldStatus, EditFieldTheme, SectionStatus } from '@/framework/base/components/FieldInfo';
  import { Alerts } from '@/framework/base/helpers/Alerts'; 
  import { storeApprenti } from '@/generated/stores';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import { Extended } from '@/framework/base/classes/Schema';
  import ButtonPlus from '@/framework/base/components/ButtonPlus.vue';
  import Route from '@/generated/classes/Route';
  import { Fiches, Sections } from '@/generated/classes/AppSchema';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  export default defineComponent({
    components: {
      SectionHeader,
      LoaderButton,
      ButtonPlus,
      ApprentiDateDebut,
      ApprentiDateFin,
      ApprentiDateRupture,
      ApprentiNom,
      ApprentiPrenom,
      CiviliteSelect,
    },

    props: {
      apprenti: {
        type: Object as PropType<Apprenti>,
        required: true
      },
      showButton: {
        type: Boolean,
      },
      autoSave: {
        type: Boolean,
      },
      fieldOnly: {
        type: Boolean,
      },
      extended: {
        type: Boolean,
      },
      autoClear: {
        type: Boolean,
      },
      dialog: {
        type: Boolean,
      },
      closeSection: {
        type: Boolean,
      },
      showMissing: {
        type: Boolean,
      },
      moduleId: {
        type: Number,
      },
      theme: {
        type: Object as PropType<EditFieldTheme>,
      },
      fiche: {
        type: String,
      },
      fromSection: {
        type: String,
      },
      requiredAttributs: {
        type: Array as PropType<string[]>,
      },
      toggleResetCiviliteSelect: {
        type: Boolean
      },
    },

    beforeUnmount (): void {
      if (!this.closeSection) {
        this.beforeClose();
      }
    },

    data() {
      return {
        dateDebutStatus: new FieldStatus(false, false, 0),
        strDateDebut: '',
        dateFinStatus: new FieldStatus(false, false, 0),
        strDateFin: '',
        dateRuptureStatus: new FieldStatus(false, false, 0),
        strDateRupture: '',
        nomStatus: new FieldStatus(false, false, 0),
        strNom: '',
        prenomStatus: new FieldStatus(false, false, 0),
        strPrenom: '',
    toggleCiviliteId: false,
        civiliteIdStatus: new FieldStatus(false, false, 0),
        strCiviliteId: '',
        refApprenti: new Apprenti,
        cloneApprenti: new Apprenti,
      apprentiSaving: false,
        saving: false,
        restoring: false,
        inDialog: false,
        updated: false,
        error: false,
        saveLoading: false,
        saveFailed: false,
        allowClearRef: true,
        objType: ObjTypes.APPRENTI,
        status: new SectionStatus(false, false, false),
        autoClose: true,
        closing: false
      }
    },
    computed: {
      isExtended (): boolean {
        return this.extended;
      },

      exist (): boolean {
        return this.editApprenti.id != 0
      },

      extendIcon (): string {
        return this.extended ? 'fas fa-circle-minus' : 'fas fa-circle-plus';
      },

      saveButton (): boolean {
        return (this.showButton == undefined || this.showButton == true) && !this.allReadOnly;
      },

      editApprenti: {
        get(): Apprenti {
          if (this.closeSection) {
            this.beforeClose();
          } else {
            if (this.apprenti != undefined) {
              if (this.apprenti.id == 0) {
                Alerts.debug('CrudApprenti : les objets passés en paramètre doivent être issus du store (id <> 0)');
              }
              if (this.cloneApprenti.id != this.apprenti.id && !this.saving) {
                this.handleApprentiChange();
              }
            }
          }
          return this.refApprenti;
        },
        set(value: Apprenti) {
          this.refApprenti = value;
        }
      },

      canCreate (): boolean {
        return this.refApprenti.id > 0;
      },

      canDelete (): boolean {
        return this.refApprenti.canDelete && this.refApprenti.id > 0;
      },

      updatedAndValid (): boolean {
        return this.updated && !this.error;
      },

      clearAuto (): boolean {
        return (this.autoClear == undefined || this.autoClear == true) && this.allowClearRef;
      },


      dateDebut: {
        get(): Date {
          return this.editApprenti.dateDebut;
        },
        set(value: Date) {
          this.editApprenti.dateDebut = value;
          this.fieldUpdated('DATE_DEBUT', value);
        }
      },

      periodDateDebut() : Period[] {
        return []
      },

      dateFin: {
        get(): Date {
          return this.editApprenti.dateFin;
        },
        set(value: Date) {
          this.editApprenti.dateFin = value;
          this.fieldUpdated('DATE_FIN', value);
        }
      },

      periodDateFin() : Period[] {
        return []
      },

      dateRupture: {
        get(): Date | null {
          return this.editApprenti.dateRupture;
        },
        set(value: Date | null) {
          this.editApprenti.dateRupture = value;
          this.fieldUpdated('DATE_RUPTURE', value);
        }
      },

      periodDateRupture() : Period[] {
        return []
      },

      nom: {
        get(): string {
          return this.editApprenti.nom;
        },
        set(value: string) {
          this.editApprenti.nom = value;
          this.fieldUpdated('NOM', value);
        }
      },


      prenom: {
        get(): string {
          return this.editApprenti.prenom;
        },
        set(value: string) {
          this.editApprenti.prenom = value;
          this.fieldUpdated('PRENOM', value);
        }
      },

    resetCiviliteId (): boolean {
      return this.toggleCiviliteId
    },

      civiliteId: {
        get(): number {
          return this.editApprenti.civiliteId;
        },
        set(value: number) {
          this.editApprenti.civiliteId = value;
          this.fieldUpdated('CIVILITE_ID', value);
        }
      },


      allReadOnly (): boolean {
        const res = this.apprenti.canUpdate && (
        (this.isDisplayed('DATE_DEBUT') && !this.readOnly('DATE_DEBUT')) ||
        (this.isDisplayed('DATE_FIN') && !this.readOnly('DATE_FIN')) ||
        (this.isDisplayed('DATE_RUPTURE') && !this.readOnly('DATE_RUPTURE')) ||
        (this.isDisplayed('NOM') && !this.readOnly('NOM')) ||
        (this.isDisplayed('PRENOM') && !this.readOnly('PRENOM')) ||
        (this.isDisplayed('CIVILITE_ID') && !this.readOnly('CIVILITE_ID')));
        return !res;
      },

      fields (): string[] {
        return ['DATE_DEBUT', 'DATE_FIN', 'DATE_RUPTURE', 'NOM', 'PRENOM', 'CIVILITE_ID'];
      },
    },

    methods: {
      handleApprentiChange() : void {
        // Edited object changed
        this.saveFailed = false;
        if (this.autoSave && this.updatedAndValid) {
          if (!this.inDialog && this.checkFields()) {
            // Dialogue to save or cancel changes
            this.inDialog = true;
            this.dialogSaveOrCancel().then(() => {
              this.createRef(this.apprenti);
              this.inDialog = false;
                  })
          } else if (!this.restoring && !this.inDialog) {
            this.restoreEdited();
            this.createRef(this.apprenti);
          }
        } else if (!this.inDialog) {
          if (this.cloneApprenti.id < 0) {
            this.clearRef();
          } else if (this.updated) {
            this.restoreEdited();
          }
          this.createRef(this.apprenti);
        }
      },
      beforeClose (): void {
        if (!this.closing) {
          this.closing = true;
          if (this.autoSave && this.updatedAndValid && this.checkFields()) {
            this.$emit('saveOrCancel');
            this.dialogSaveOrCancel();
          } else {
            if (this.autoSave && this.updated) {
              this.restoreEdited();
            }
            this.$emit('cancelled');
          }
          this.clearRef();
          }
      },

      setExtended (extended: Extended): void {
         this.$emit('extended', extended);
      },

      // eslint-disable-next-line
      isDisplayed (value: string): boolean {
        return true;
      },

      // eslint-disable-next-line
      required (value: string): boolean {
        return false;
      },

      // eslint-disable-next-line
      readOnly (value: string): boolean {
        return false;
      },

      save (): void {
        if (event != undefined) {
          event.stopPropagation();
        }
        this.saveLoading = true;
        this.saveFailed = false;
        if (this.checkFields()) {
          this.saveObj();
        } else {
        this.saveLoading = false;
          this.saveFailed = true;
        }
      },

      setUpdated (): void {
        const updated = (this.dateDebutStatus != undefined && this.dateDebutStatus.updated) ||
          (this.dateFinStatus != undefined && this.dateFinStatus.updated) ||
          (this.dateRuptureStatus != undefined && this.dateRuptureStatus.updated) ||
          (this.nomStatus != undefined && this.nomStatus.updated) ||
          (this.prenomStatus != undefined && this.prenomStatus.updated) ||
          (this.civiliteIdStatus != undefined && this.civiliteIdStatus.updated);
        if (updated != this.updated) {
          this.updated = updated;
          this.status.updated = updated;
          this.status.missing = this.hasMissing();
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.apprenti);
        }
      },

      setError (): void {
        const error = this.dateDebutStatus.error ||
        this.dateFinStatus.error ||
        this.dateRuptureStatus.error ||
        this.nomStatus.error ||
        this.prenomStatus.error ||
        this.civiliteIdStatus.error;
        if (error != this.error) {
          if (!error) {
            this.saveFailed = false;
          }
          this.error = error;
          this.status.error = error;
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.apprenti);
        }
      },

      // Clear non saved new objects when leaving
      clearRef (): void {
        if (this.clearAuto && this.refApprenti.id < 0) {
          storeApprenti.mApprentiDeleted(this.refApprenti.id);
        }
      },

      // Dialog to save or ignore changes when loosing focus or changing edited item
      dialogSaveOrCancel (): Promise<boolean> {
        return new Promise((resolve) => {
          if (!this.error) {
            Alerts.saveOrCancel()
              .then((result: boolean) => {
                if (result) {
                  this.saveObj();
                } else {
                  if (this.refApprenti.id <= 0) {
                    this.deleteObj();
                  } else {
                    this.restoreEdited();
                  }
                  this.$emit('cancelled');
                }
                resolve(result);
              })
          } else {
            this.restoreEdited();
          }
        })
      },

      // Save object and subobjects referenced by foreignClass keys
      saveObj (): void {
        this.saving = true;
        if (
          this.saveApprenti()
          ) {
          this.saving = false;
          this.saveLoading = false;
          this.apprentiSaving = false;
          this.createRef(this.refApprenti);
          this.$emit('updated', this.refApprenti);
          if (this.apprenti.id > 0) {
            this.$emit('saved', this.refApprenti);
          } else {
            this.updated = true;
          }
          if (this.autoClose) {
            this.saveFields();
            this.$emit('closeDialog');
          }
        } else {
          if (this.refApprenti.failed) {
          this.saveLoading = false;
            this.apprentiSaving = false;
            this.refApprenti.failed = false;
          }
        }
      },

      saveApprenti (): boolean {
        if (!this.refApprenti.compareApprenti(this.cloneApprenti)) {
          if (!this.apprentiSaving) {
            this.apprentiSaving = true;
          if (this.refApprenti.id > 0) {
            storeApprenti.updateApprenti(this.refApprenti)
              .then((data: Apprenti) => {
                if (!data.failed) {
                  this.refApprenti = storeApprenti.getApprenti(data.id);
                  this.cloneApprenti = data.cloneApprenti();
                } else {
                  this.refApprenti.failed = true;
                }
                this.saveObj();
              })
              .catch(() => {
                this.restoreEdited();
                this.apprentiSaving = false;
                this.saveLoading = false;
              })
          }
            if (this.refApprenti.id <= 0) {
              storeApprenti.createApprenti(this.refApprenti)
                .then((data: Apprenti) => {
                  if (!data.failed) {
                    this.refApprenti = storeApprenti.getApprenti(data.id);
                    this.cloneApprenti = data.cloneApprenti();
                  } else {
                this.refApprenti.failed = true;
                  }
                  this.saveObj();
                })
                .catch(() => {
                  this.restoreEdited();
                    this.apprentiSaving = false;
                })
            }
          }
          return false;
        } else {
          return true;
        }
      },

      // Delete object
      deleteObj (): void {
        if (this.refApprenti.id <= 0) {
          storeApprenti.mApprentiDeleted(this.refApprenti.id);
        } else {
          storeApprenti.deleteApprenti(this.refApprenti);
        }
      },

      statusDateDebut (value: FieldStatus): void {
        this.dateDebutStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusDateFin (value: FieldStatus): void {
        this.dateFinStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusDateRupture (value: FieldStatus): void {
        this.dateRuptureStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusNom (value: FieldStatus): void {
        this.nomStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusPrenom (value: FieldStatus): void {
        this.prenomStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusCiviliteId (value: FieldStatus): void {
        this.civiliteIdStatus = value;
        this.setUpdated();
        this.setError();
      },

      deleteApprenti(): void {
        this.$emit('deleteApprenti',  this.apprenti);
      },

    addApprenti(): void {
      this.$emit('addApprenti',  this.apprenti);
    },

      // Restore object
      restoreEdited (): void {
        if (this.cloneApprenti != undefined) {
          this.restoring = true;
          this.refApprenti.dateDebut = this.cloneApprenti.dateDebut;
          this.refApprenti.dateFin = this.cloneApprenti.dateFin;
          this.refApprenti.dateRupture = this.cloneApprenti.dateRupture;
          this.refApprenti.nom = this.cloneApprenti.nom;
          this.refApprenti.prenom = this.cloneApprenti.prenom;
          this.refApprenti.civiliteId = this.cloneApprenti.civiliteId;
          this.restoring = false;
        }
      },


    // Clone and clear edited
      createRef (value: Apprenti): void {
        this.clearRef();
        this.editApprenti = value;
        this.cloneApprenti = value.cloneApprenti();
        this.dateDebutStatus.clear(value.id);
        this.dateFinStatus.clear(value.id);
        this.dateRuptureStatus.clear(value.id);
        this.nomStatus.clear(value.id);
        this.prenomStatus.clear(value.id);
        this.civiliteIdStatus.clear(value.id);
        this.status.clear();
      },

    checkFields (): boolean {
        // @ts-expect-error : generated method
        if (this.isDisplayed('DATE_DEBUT') && this.$refs.DATE_DEBUT) this.$refs.DATE_DEBUT.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('DATE_FIN') && this.$refs.DATE_FIN) this.$refs.DATE_FIN.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('DATE_RUPTURE') && this.$refs.DATE_RUPTURE) this.$refs.DATE_RUPTURE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NOM') && this.$refs.NOM) this.$refs.NOM.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PRENOM') && this.$refs.PRENOM) this.$refs.PRENOM.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('CIVILITE_ID') && this.$refs.CIVILITE_ID) this.$refs.CIVILITE_ID.touch();
        return !this.error;
      },

      missing (value: string): boolean {
        return this.hasMissing(value);
      },

      hasMissing (value = ''): boolean {
        let missing = false;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'DATE_DEBUT') && this.isDisplayed('DATE_DEBUT') && this.$refs.DATE_DEBUT && this.$refs.DATE_DEBUT.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'DATE_FIN') && this.isDisplayed('DATE_FIN') && this.$refs.DATE_FIN && this.$refs.DATE_FIN.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'DATE_RUPTURE') && this.isDisplayed('DATE_RUPTURE') && this.$refs.DATE_RUPTURE && this.$refs.DATE_RUPTURE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'NOM') && this.isDisplayed('NOM') && this.$refs.NOM && this.$refs.NOM.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'PRENOM') && this.isDisplayed('PRENOM') && this.$refs.PRENOM && this.$refs.PRENOM.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'CIVILITE_ID') && this.isDisplayed('CIVILITE_ID') && this.$refs.CIVILITE_ID && this.$refs.CIVILITE_ID.missing()) missing = true;
        return missing;
      },

      saveFields (): void {
        // @ts-expect-error : generated method
        if (this.isDisplayed('DATE_DEBUT') && this.$refs.DATE_DEBUT) this.$refs.DATE_DEBUT.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('DATE_FIN') && this.$refs.DATE_FIN) this.$refs.DATE_FIN.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('DATE_RUPTURE') && this.$refs.DATE_RUPTURE) this.$refs.DATE_RUPTURE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NOM') && this.$refs.NOM) this.$refs.NOM.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PRENOM') && this.$refs.PRENOM) this.$refs.PRENOM.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('CIVILITE_ID') && this.$refs.CIVILITE_ID) this.$refs.CIVILITE_ID.save();
      },

      getValue (field: string): string {
         if (field == 'DATE_DEBUT') return this.dateDebut.toString();
        else  if (field == 'DATE_FIN') return this.dateFin.toString();
        else  if (field == 'DATE_RUPTURE') return this.dateRupture == null ? '' : this.dateRupture.toString();
        else  if (field == 'NOM') return this.nom.toString();
        else  if (field == 'PRENOM') return this.prenom.toString();
        else  if (field == 'CIVILITE_ID') return this.civiliteId.toString();
        else return '';
      },

    // eslint-disable-next-line
    fieldUpdated (field: string, value: unknown): void {
      // To implement
    },

      setFocus (route: Route): boolean {
        let res = false;
        let first = '';
        const attribut = route ? route.attribut : '';
        this.fields.forEach(field => {
          // @ts-expect-error : generated method
          if (!res && this.isDisplayed(field) && !this.readOnly(field) && this.$refs[field].setFocus) {
            if (attribut == field) {
              // @ts-expect-error : generated method
              this.$refs[attribut].setFocus();
              res = true;
            } else if (first == '') {
              first = field;
            }
          }
        })
        // @ts-expect-error : generated method
        if (!res && first != '' && this.$refs[first] && this.$refs[first].setFocus) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus();
          res = true;
        }
        return res
      },

      closeDialog(): void {
        this.$emit('closeDialog')
      }
    },
  })
